// src/utils/pegman.ts
import L from "leaflet";
import "leaflet-pegman";
import "leaflet-pegman/leaflet-pegman.css";

type Corner = "topleft" | "topright" | "bottomleft" | "bottomright";

export function attachPegman(
  map: L.Map,
  opts: { position?: Corner; theme?: string } = {}
) {
  const control = new (L.Control as any).Pegman({
    position: opts.position ?? "bottomright",
    theme: opts.theme ?? "leaflet-pegman-v3-default",
  });
  control.addTo(map);
  return () => {
    try {
      map.removeControl(control);
    } catch {}
  };
}
